import { v4 } from 'uuid';
import { TableSettings } from '../TableSettings';
import { EntityType } from '../../comment';
import { translate } from '../../translation/Translator';

export const OrderTableSettingsColumn = {
  order: 'order',
  type: 'type',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  sourceStockLocation: 'sourceStockLocation',
  destinationStockLocation: 'destinationStockLocation',
  status: 'status',
  contact: 'contact',
  pdf: 'pdf',
  assignedTo: 'assignedTo',
} as const;

export type OrderTableSettingsColumn = (typeof OrderTableSettingsColumn)[keyof typeof OrderTableSettingsColumn];

export class OrderTableSettings {
  static default(companyId: string) {
    return new TableSettings<OrderTableSettingsColumn>({
      id: v4(),
      companyId,
      type: EntityType.order,
      columns: [
        {
          index: 0,
          column: OrderTableSettingsColumn.order,
          label: translate({ key: OrderTableSettingsColumn.order }),
        },
        {
          index: 1,
          column: OrderTableSettingsColumn.type,
          label: translate({ key: OrderTableSettingsColumn.type }),
        },
        {
          index: 2,
          column: OrderTableSettingsColumn.createdAt,
          label: translate({ key: OrderTableSettingsColumn.createdAt }),
        },
        {
          index: 3,
          column: OrderTableSettingsColumn.sourceStockLocation,
          label: translate({ key: OrderTableSettingsColumn.sourceStockLocation }),
        },
        {
          index: 4,
          column: OrderTableSettingsColumn.destinationStockLocation,
          label: translate({ key: OrderTableSettingsColumn.destinationStockLocation }),
        },
        {
          index: 5,
          column: OrderTableSettingsColumn.status,
          label: translate({ key: OrderTableSettingsColumn.status }),
        },
      ],
    });
  }
}
